import { FC, ReactNode, useState } from 'react';
import classes from './JsonViewer.module.scss';
import { Props } from './types';


export const JsonViewer: FC<Props> = ({ inputKey, inputValue, isLast }) => {
  const [isOpen, setOpen] = useState(true);

  const coma = isLast ? '' : ',';
  const inputType = (typeof inputValue).toLowerCase();
  const inputKeyLabel = inputKey ? `"${inputKey}": ` : '';


  if (['string'].includes(inputType)) {
    return <div>{`${inputKeyLabel}"${inputValue}"`}{coma}<span className={classes.meta}>{inputType}</span></div>;
  }

  if (['boolean'].includes(inputType)) {
    return <div>{`${inputKeyLabel}${inputValue ? 'true' : 'false'}`}{coma}<span className={classes.meta}>{inputType}</span></div>;
  }

  if (['number', 'null'].includes(inputType)) {
    return <div>{`${inputKeyLabel}${inputValue}`}{coma}<span className={classes.meta}>{inputType}</span></div>;
  }

  const expandIcon = (
    <svg onClick={() => setOpen(!isOpen)} className={isOpen ? '' : classes.rotate} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.80455 7.138L7.52855 10.862C7.78922 11.1227 8.21122 11.1227 8.47122 10.862L12.1952 7.138C12.6152 6.718 12.3179 6 11.7239 6H4.27588C3.68188 6 3.38455 6.718 3.80455 7.138Z" fill="#757575"/>
    </svg>
  );

  if (Array.isArray(inputValue)) {
    const array: ReactNode[] = [];

    for (let i = 0; i < inputValue.length; i++) {
      array.push((
        <JsonViewer
          key={i}
          inputKey={i.toString()}
          inputValue={inputValue[i]}
          isLast={i === inputValue.length - 1}
        />
      ));
    }

    return (
      <div className={classes.wrapper}>
        <div className={classes.keyName}>
          {expandIcon}
          {inputKeyLabel}{isOpen ? '[ ' : '[ ... ]'}
          <span className={classes.meta}>Array (length {array.length})</span>
        </div>

        {isOpen && (
          <>
            <div className={classes.content}>
              {array}
            </div>

            <div className={classes.bracket}>]{coma}</div>
          </>
        )}
      </div>
    );
  }

  const objArray: ReactNode[] = [];
  const objectKeys = Object.keys(inputValue);

  for (let i = 0; i < objectKeys.length; i++) {
    objArray.push((
      <JsonViewer
        key={i}
        inputKey={objectKeys[i]}
        inputValue={inputValue[objectKeys[i]]}
        isLast={i === objectKeys.length - 1}
      />
    ));
  }

  return (
    <div className={classes.wrapper}>
      <div className={classes.keyName}>
        {expandIcon}
        {inputKeyLabel}{isOpen ? '{ ': '{ ... }'}
        <span className={classes.meta}>Object ({objArray.length} key{objArray.length > 1 ? 's': ''})</span>
      </div>

      {isOpen && (
        <>
          <div className={classes.content}>
            {objArray}
          </div>

          <div className={classes.bracket}>{`}${coma}`}</div>
        </>
      )}
    </div>
  );
};
